import { useState } from "react";
import { type Role } from "../shared/constants";
import PlayerLogin from "../components/PlayerLogin";
import AdminLogin from "../components/AdminLogin";

interface LoginPageProps {
  onLogin: (loginData: {
    playerId: string;
    gameName: string;
    teamName: string;
    teamCodeName: string;
    role: Role;
    loginCode: string;
    communicationLevel: number | null;
    scanningLevel: number | null;
    spaceshipDamage: number | null;
    personalScore: number;
    accessToken: string;
    refreshToken: string;
  }) => void;
  onAdminLogin: (adminData: {
    adminId: string;
    userName: string;
    accessToken: string;
    refreshToken: string;
  }) => void;
}

export default function LoginPage({ onLogin, onAdminLogin }: LoginPageProps) {
  const [loginMode, setLoginMode] = useState<"select" | "player" | "admin">("select");

  // Show login mode selection
  if (loginMode === "select") {
    return (
      <div style={{ 
        padding: "2rem", 
        backgroundColor: "#f8f9fa", 
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{
          textAlign: "center",
          maxWidth: "600px",
          width: "100%"
        }}>
          {/* Title */}
          <div style={{ marginBottom: "3rem" }}>
            <h1 style={{ 
              margin: "0 0 0.5rem 0", 
              fontSize: "2.5rem",
              color: "#212529",
              fontWeight: "bold"
            }}>
              🌠 Lost in Space 🚀
            </h1>
            <p style={{ 
              fontSize: "1.1rem", 
              color: "#6c757d",
              margin: 0
            }}>
              Choose your login type to continue
            </p>
          </div>

          {/* Login Options */}
          <div style={{ 
            display: "flex", 
            gap: "1.5rem",
            justifyContent: "center",
            flexWrap: "wrap"
          }}>
            <button 
              onClick={() => setLoginMode("player")}
              style={{ 
                padding: "1.5rem 3rem", 
                fontSize: "1.1rem", 
                cursor: "pointer",
                backgroundColor: "#007bff",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontWeight: "bold",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                transition: "all 0.2s",
                minWidth: "200px"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#0056b3";
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#007bff";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
              }}
            >
              Player Login
            </button>
            <button 
              onClick={() => setLoginMode("admin")}
              style={{ 
                padding: "1.5rem 3rem", 
                fontSize: "1.1rem", 
                cursor: "pointer",
                backgroundColor: "#28a745",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontWeight: "bold",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                transition: "all 0.2s",
                minWidth: "200px"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#218838";
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#28a745";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
              }}
            >
              Admin Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Show admin login
  if (loginMode === "admin") {
    return (
      <AdminLogin 
        onBack={() => setLoginMode("select")}
        onLogin={onAdminLogin}
      />
    );
  }

  // Show player login form
  return (
    <PlayerLogin 
      onLogin={onLogin} 
      onBack={() => setLoginMode("select")} 
    />
  );
}

